<template>
  <v-alert
    border="left"
    class="mb-0"
    :color="styleSet.color"
    dismissible
    v-bind="{ ...styleSet.options, ...$attrs }"
    @input="visibleChange"
  >
    <div class="d-flex align-center">
      <v-icon v-if="styleSet.icon" class="mr-4" :color="styleSet.textColor">{{
        styleSet.icon
      }}</v-icon>
      <div class="font-weight-bold" :style="{ color: styleSet.textColor }"><slot></slot></div>
    </div>
    <!-- <template v-slot:close="{ toggle }">
      <v-btn @click="closeAlert(toggle)">Close</v-btn>
    </template> -->
  </v-alert>
</template>

<script>
export default {
  name: 'FletrixAlert',
  props: {
    type: {
      type: String,
      default: 'default',
      validator(value) {
        return ['notice', 'memo', 'default'].includes(value);
      },
    },
    icon: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    textColor: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      styleOfType: {
        notice: {
          icon: 'mdi-bell',
          color: 'orange',
          textColor: 'orange',
          options: {
            outlined: true,
          },
        },
        memo: {
          icon: 'mdi-bullhorn-variant',
          color: '#E040FB',
          textColor: '#FFFFFF',
        },
        default: {
          icon: 'mdi-information-outline',
          color: '#333',
          textColor: '',
          options: {
            outlined: true,
          },
        },
      },
    };
  },
  computed: {
    styleSet() {
      let typeStyle = this.styleOfType[this.type] || {};
      this.icon && (typeStyle.icon = this.icon);
      this.color && (typeStyle.color = this.color);
      this.textColor && (typeStyle.textColor = this.textColor);
      return typeStyle;
    },
  },
  methods: {
    visibleChange(e) {
      if (!e) {
        this.$emit('dismiss');
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
